// extracted by mini-css-extract-plugin
export var aboveInput = "_lq-0";
export var actionButton = "_lq-5";
export var actionButtonContainer = "_lq-1";
export var actionIcon = "_lq-6";
export var aiInfoContainer = "_lq-2";
export var attachmentWrapper = "_lq-7";
export var bold = "_lq-3";
export var checkIcon = "_lq-8";
export var clickingRecipientBar = "_lq-11";
export var commentThreadSwitch = "_lq-a";
export var draftImage = "_lq-b";
export var draftImageContainer = "_lq-c";
export var draftImages = "_lq-e";
export var editButton = "_lq-g";
export var editor = "_lq-f";
export var editorContainer = "_lq-y";
export var editorErrorTooltipWrapper = "_lq-9";
export var headerDivider = "_lq-h";
export var icon = "_lq-i";
export var info = "_lq-j";
export var internal = "_lq-n";
export var internalDivider = "_lq-k";
export var internalMessage = "_lq-l";
export var messageInputCard = "_lq-m";
export var messageInputForm = "_lq-o";
export var messageInputFormInternal = "_lq-p";
export var options = "_lq-q";
export var publicMessageCustomer = "_lq-s";
export var publicMessageMerchant = "_lq-r";
export var removeImageButton = "_lq-d";
export var replyButtons = "_lq-t";
export var showSignatureButton = "_lq-u";
export var spinner = "_lq-v";
export var verticalButtonDivider = "_lq-4";
export var visibilitySelector = "_lq-w";
export var warning = "_lq-x";
export var wrappingText = "_lq-z";
export var writingInternalNoteTopBorder = "_lq-10";